// @flow
import { ApiService } from './api-service';

type Headers = {
  'Content-Type': string,
  'x-dothealth-token'?: string,
}

export class PublicApiService extends ApiService {
  get token(): ?string {
    return localStorage.getItem('view_token');
  }

  get headers(): Headers {
    const headers = {
      ...super.headers
    };
    headers['Content-Type'] = 'application/json';
    if (this.token != null) {
      headers['x-dothealth-token'] = this.token;
    }

    return headers;
  }
}

export default new PublicApiService();



// WEBPACK FOOTER //
// ./src/services/public-api-service.js